module.exports = __webpack_public_path__ + "toGroom-we-w-g.1904f956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-w-g.jpg
// module id = FKe6
// module chunks = 0